import React, { useContext, useState } from "react";
import { FormLabel, FormElement, FormInput, BackLink, Button, CancelButton, PageTitle, PageHeader } from "../../../components/StyledElements";
import MediaTable from "../../../components/Tables/MediaTable";
import { useNavigate } from "react-router-dom";
import { useDataSets } from "../../../contexts/DataSetsContext";
import { AppContext } from "../../../contexts/AppContext";


export const CreateCourse = ({ style = {}, onSelectTab = () => { } }) => {
  const navigate = useNavigate();
  const { getDataSetItem } = useDataSets();
  const { media } = useContext(AppContext);
  const [newCourse, setNewCourse] = useState({
    public_id: "",
    title: "",
    short_title: "",
    description: "",
    instructions: "",
    media_items: [],
  });

  const [courseDataItems, setCourseDataItems] = useState([]);

  const generateCourse = () => {
    // Logic to generate course goes here
    console.log("Generating course with details: ", newCourse);
    // For now, just navigate back to courses list
  };

  return (
    <div
      style={{
        marginLeft: "20px",
        marginRight: "20px",
        width: "100%",
        minHeight: "calc(100vh - 40px)",
        position: "relative",
        backgroundColor: "var(--content-item-bg)",
        padding: "20px",
        borderRadius: "8px",
        color: "var(--main-font-color)",
        zIndex: 1,
      }}>
      <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
        <div>
          <BackLink onClick={() => {
            navigate(`/courses`);
          }} >
            <i className="fa fa-arrow-left" /> Back to Courses</BackLink>
          <PageTitle title="New Course" style={{ marginBottom: "0px" }} />
        </div>
        <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
          <CancelButton onClick={() => {
            navigate(`/courses`);
          }}>Cancel</CancelButton>
          <Button disabled={false} onClick={generateCourse} style={{ marginLeft: "auto" }}>{"Generate Course"}</Button>
        </div>
      </PageHeader>

      <FormElement style={{ flexDirection: "column", display: "flex" }}>
        {
          newCourse?.document_count ? (
            <FormLabel label={`${newCourse.document_count} Items`} />
          ) : null}
        {
          newCourse?.collection_chunk_count ? (
            <FormLabel label={`${newCourse.collection_chunk_count} Chunked Items`} />
          ) : null}
      </FormElement>

      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={newCourse?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Title" />
        <FormInput type="text" placeholder="Enter course title" value={newCourse?.title ?? ""}
          onChange={(e) => {
            setNewCourse({ ...newCourse, title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Short Title" />
        <FormInput type="text" placeholder="Enter course short title" value={newCourse?.short_title ?? ""}
          onChange={(e) => {
            setNewCourse({ ...newCourse, short_title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={newCourse?.description ?? ""}
          onChange={(e) => {
            newCourse.description = e.target.value;
            setNewCourse({ ...newCourse });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Purpose" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter purpose"
          style={{ resize: "vertical" }}
          value={newCourse?.purpos ?? ""}
          onChange={(e) => {
            newCourse.purpose = e.target.value;
            setNewCourse({ ...newCourse });
          }}
        />
      </FormElement>
      <div style={{ width: "100%", position: "relative", ...style }}>
        <MediaTable media={courseDataItems} showAddExisting={true} isDataSet={false} hideTitle={true} onSelectSave={(dataItems) => {
          console.log("!!! SELECTED COURSE DATA ITEMS: ", dataItems, media);

          const updatedNewCourse = { ...newCourse };
          updatedNewCourse.media_item = [...newCourse.media_items, ...dataItems];
          setNewCourse(updatedNewCourse);

          dataItems.forEach((di) => {
            const mediaItem = media.find((m) => m.public_id === di);
            if (mediaItem) {
              console.log("!!! FOUND MEDIA ITEM: ", mediaItem);
              const dataItem = getDataSetItem(di.data_set_item_public_id);
              setCourseDataItems((prev) => [...prev, { ...mediaItem, data_item: dataItem }]);
            }
          });
        }} />
      </div >
    </div >
  );
};

export default CreateCourse;
